import { NgModule } from '@angular/core';
import { combineReducers, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { sustainabilityReducers, sustainabilitySelectorKey } from './store';
import { RabobankFormEffects } from './store/rabobank/rabobank-form.effects';
import { GetTimeslotsEffects } from './store/get-timeslots/get-timeslots.effects';
import { GetTimeslotsTimesService } from './store/get-timeslots/api/get-timeslots-times.service';

@NgModule({
  imports: [
    StoreModule.forFeature(
      sustainabilitySelectorKey,
      combineReducers(sustainabilityReducers)
    ),
    EffectsModule.forFeature([RabobankFormEffects, GetTimeslotsEffects]),
  ],
  providers: [GetTimeslotsTimesService],
})
export class SustainabilityBootstrapModule {}
